import { api } from './client';
import type { AuthUser, AuthPractice } from '@/stores/auth';

// Post-cutover (ADR 0002 / 0004), authentication is upstream — Cognito
// in test/prod, the stub IdP in local dev. This module's surface
// shrank further with the dev-login unification: only fetchMe and
// logoutApi remain. The dev login() helper went away alongside
// pma-server's /api/dev/login route — every sign-in now goes through
// the IdP redirect instead.

export interface MeResponse {
    user: AuthUser;
    practice: AuthPractice;
    gs_staff: boolean;
    acting_as_practice_id: string | null;
    entitlements: string[];
}

/**
 * Fetches the calling user's PMA-resolved profile + practice. Called
 * by AuthCallbackPage after the OAuth token exchange to populate the
 * auth store with the rich {user, practice} payload the app needs.
 */
export async function fetchMe(): Promise<MeResponse> {
    const res = await api.get<MeResponse>('/me');
    return res.data;
}

/**
 * Local-only logout. The full sign-out also bounces through the IdP
 * /logout — that part lives in TopBar's handleLogout. This function
 * is here as a hook for future server-side teardown (auditing the
 * sign-out, dropping a refresh token, etc.).
 */
export async function logoutApi(): Promise<void> {
    // No-op against the platform JWT model — the auth store clears
    // localStorage on logout(), and the next request gets 401.
}
